import { axiosEduServer, BASE_URL } from "../utils/configAxios";

const blobToDataURL = (blob) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });

export const getImagePerfil = async (fileName) => {
  if (!fileName || fileName.trim() === "") {
    throw new Error("FileName vacío o inválido");
  }

  const encoded = encodeURIComponent(fileName);
  const endpoints = [
    `/persona/images/perfil/${encoded}`,
    `/images/perfil/${encoded}`,
  ];

  let notFound = false;
  let lastError = null;

  for (const path of endpoints) {
    try {
      const { data } = await axiosEduServer.get(path, { responseType: "blob" });
      return blobToDataURL(data);
    } catch (error) {
      lastError = error;
      if (error.response?.status === 404) {
        notFound = true;
        continue;
      }
    }
  }

  if (notFound && !lastError) {
    const notFoundError = new Error(`Imagen no encontrada en el servidor: ${fileName}`);
    notFoundError.status = 404;
    notFoundError.isNotFound = true;
    throw notFoundError;
  }

  const origin = (() => {
    try {
      return new URL(BASE_URL).origin;
    } catch {
      return BASE_URL.replace(/\/?api\/?$/, "");
    }
  })();

  try {
    const directUrl = `${origin}/images/perfil/${encoded}`;
    const userInfo = JSON.parse(localStorage.getItem("userInfoES") || "{}");
    const headers = userInfo?.token ? { Authorization: `Bearer ${userInfo.token}` } : {};

    const response = await fetch(directUrl, { headers });

    if (response.ok) {
      return blobToDataURL(await response.blob());
    }

    if (response.status === 404) {
      const notFoundError = new Error(`Imagen no encontrada en el servidor: ${fileName}`);
      notFoundError.status = 404;
      notFoundError.isNotFound = true;
      throw notFoundError;
    }

    throw new Error(`HTTP ${response.status}: ${response.statusText}`);
  } catch (error) {
    const isCorsError =
      error instanceof TypeError &&
      (error.message === "Failed to fetch" ||
        error.message === "NetworkError when attempting to fetch resource");

    if (isCorsError) {
      error.isCorsError = true;
      error.message = "No se pudo acceder al recurso remoto (posible CORS o conexión bloqueada)";
    }

    if (error.isNotFound || error.status === 404 || notFound) {
      throw error;
    }

    const fallback = new Error(
      `No se pudo cargar la imagen desde ninguna ruta disponible. Último error: ${
        error.message || lastError?.message || "desconocido"
      }`
    );
    if (isCorsError) {
      fallback.isCorsError = true;
    }
    throw fallback;
  }
};

export const uploadImagePerfil = async (file) => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    // Nota: axiosEduServer ya tiene baseURL con /api, por eso el path correcto es /persona/images/perfil
    const { data } = await axiosEduServer.post(`/persona/images/perfil`, formData);
    // data => { fileName }
    return data;
  } catch (err) {
    throw err;
  }
};